export var convertToUpdateDto = function (data) {
    var dtoData = {
        username: data.username,
    };
    return dtoData;
};
